import CompactEmptyState from 'components/EmptyState/CompactEmptyState';
import PageForm from 'components/pageForm/PageForm';
import StatsGoalsCard from 'components/stats/StatsGoalsCard';
import useCrmContext from 'hooks/useCrmContext';
import useText from 'hooks/useText';
import { useCallback, useEffect, useState } from 'react';
import crmApi from 'server/crm/crmApi';

/**
 * « Paramètres · Objectifs » of the admin console, as on the prototype: the
 * weekly goal of each commercial, which the statistics show.
 */
const AdminGoals = () => {
  const { text } = useText('adminConsole');
  const { call, ready } = useCrmContext();
  const [team, setTeam] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(() => {
    setFailed(false);
    call(crmApi.getTeam).then(setTeam, () => setFailed(true));
  }, [call]);
  useEffect(() => {
    if (ready) load();
  }, [ready, load]);

  return (
    <PageForm title={text('goalsPageTitle')}>
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-5 px-4 py-6 lg:px-8">
        {failed && (
          <CompactEmptyState
            title={text('goalsLoadError')}
            action={{ label: text('goalsRetry'), onClick: load }}
          />
        )}
        {!failed && !team && (
          <div
            className="h-40 animate-pulse rounded-lg bg-gray-100"
            aria-busy="true"
          />
        )}
        {!failed && team && <StatsGoalsCard members={team} />}
      </div>
    </PageForm>
  );
};

export default AdminGoals;
